export default {"src":"/_next/static/media/0x408e41876cccdc0f92210600ef50372656052a38.98856cb1.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};